var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-expansion-panels",
    [
      _c(
        "v-expansion-panel",
        [
          _c("v-expansion-panel-header", { staticClass: "accordion-header" }, [
            _vm._v(" Variazioni comunicate "),
          ]),
          _c(
            "v-expansion-panel-content",
            [
              _vm.contieneVariazioniStoricizzate
                ? _c("v-checkbox", {
                    staticStyle: { "margin-top": "5px", height: "30px" },
                    attrs: { label: "Mostra anche le variazioni già validate" },
                    model: {
                      value: _vm.mostraVariazioniStoricizzate,
                      callback: function ($$v) {
                        _vm.mostraVariazioniStoricizzate = $$v
                      },
                      expression: "mostraVariazioniStoricizzate",
                    },
                  })
                : _vm._e(),
              !_vm.mostraVariazioniStoricizzate &&
              _vm.variazioniDaMostrare.length == 0
                ? _c("div", [
                    _vm._v(
                      " Nessuna variazione in attesa di validazione presente... "
                    ),
                  ])
                : _vm._e(),
              _vm._l(_vm.variazioniDaMostrare, function (variazione, index) {
                return _c(
                  "div",
                  { key: "var_" + index, staticClass: "variazione-container" },
                  [
                    _c("div", [
                      _vm._v(
                        " Comunicazione #" +
                          _vm._s(variazione.indice) +
                          " del " +
                          _vm._s(
                            _vm._f("formatDateTime")(
                              variazione.dataComunicazione
                            )
                          ) +
                          " da fornitore: " +
                          _vm._s(variazione.idFornitore) +
                          " "
                      ),
                    ]),
                    variazione.statoValidazione ==
                      _vm.StatoVariazione.RigaModificataDalFornitore ||
                    variazione.statoValidazione ==
                      _vm.StatoVariazione.RigaModificataDaBC
                      ? _c(
                          "ul",
                          _vm._l(
                            _vm.rigaDistinta.quantitaPerTaglia,
                            function (qta, i2) {
                              return _c(
                                "li",
                                {
                                  key: "li_" + variazione.indice + i2,
                                  class: {
                                    "red--text":
                                      variazione
                                        .quantitaPerTagliaPreComunicazione[
                                        qta.indice - 1
                                      ] !=
                                      variazione.quantitaPerTagliaComunicate[
                                        qta.indice - 1
                                      ],
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        (+variazione
                                          .quantitaPerTagliaComunicate[
                                          qta.indice - 1
                                        ])
                                          .toFixed(2)
                                          .replace(".", ",")
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : variazione.statoValidazione ==
                          _vm.StatoVariazione.RigaEliminataDalFornitore ||
                        variazione.statoValidazione ==
                          _vm.StatoVariazione.RigaEliminataDaBC
                      ? _c("div", [_vm._v(" Eliminazione riga ")])
                      : variazione.statoValidazione ==
                          _vm.StatoVariazione.RigaAggiuntaDalFornitore ||
                        variazione.statoValidazione ==
                          _vm.StatoVariazione.RigaAggiuntaDaBC
                      ? _c("div", [_vm._v(" Inserimento riga ")])
                      : _vm._e(),
                  ]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }